// The calendar's "Edit series" asks the next opening of that appointment to start on the Series tab.
let requestedId: number | null = null

export const requestSeriesTab = (appointmentId: number): void => {
  requestedId = appointmentId
}

export const peekSeriesTab = (appointmentId: number): boolean => requestedId === appointmentId

export const clearSeriesTab = (): void => {
  requestedId = null
}
